var content = require("!!../node_modules/.pnpm/@angular-devkit+build-angular@0.900.7_@angular+compiler-cli@9.0.7_typescript@3.7.7/node_modules/@angular-devkit/build-angular/src/angular-cli-files/plugins/raw-css-loader.js!../node_modules/.pnpm/postcss-loader@3.0.0/node_modules/postcss-loader/src/index.js??embedded!../node_modules/.pnpm/sass-loader@8.0.0_sass@1.23.3_webpack@4.41.2/node_modules/sass-loader/dist/cjs.js??ref--13-3!./custom-theme.scss");

if (typeof content === 'string') {
  content = [[module.id, content, '']];
}

var options = {}

options.insert = "head";
options.singleton = false;

var update = require("!../node_modules/.pnpm/style-loader@1.0.0_webpack@4.41.2/node_modules/style-loader/dist/runtime/injectStylesIntoStyleTag.js")(content, options);

if (content.locals) {
  module.exports = content.locals;
}
